export var MutationTypes;
(function (MutationTypes) {
    MutationTypes["SET_USERNAME"] = "SET_USERNAME";
    MutationTypes["SET_ACCESS_TOKEN"] = "SET_ACCESS_TOKEN";
    MutationTypes["SET_AUTHENTIFIED"] = "SET_AUTHENTIFIED";
    MutationTypes["RESET_USER_STATE"] = "RESET_USER_STATE";
    MutationTypes["SET_ACCOUNT"] = "SET_ACCOUNT";
})(MutationTypes || (MutationTypes = {}));
